/**
 * Tracker analytics maison — pas de cookies, juste un session_id dans localStorage.
 * Anonyme, RGPD-friendly.
 */
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SID_KEY = "urbx_sid";

function getSessionId() {
  try {
    let sid = localStorage.getItem(SID_KEY);
    if (!sid) {
      // 24 hex chars, suffisamment unique pour un usage analytics anonyme
      sid =
        Date.now().toString(36) +
        Math.random().toString(36).slice(2, 10) +
        Math.random().toString(36).slice(2, 10);
      localStorage.setItem(SID_KEY, sid);
    }
    return sid;
  } catch {
    return "anon-" + Math.random().toString(36).slice(2, 14);
  }
}

export async function track(eventType, extra = {}) {
  try {
    await axios.post(`${API}/analytics/track`, {
      session_id: getSessionId(),
      event_type: eventType,
      path: extra.path || window.location.pathname + window.location.hash,
      referrer: extra.referrer ?? document.referrer ?? "",
    });
  } catch (err) {
    // Pas de crash UI si tracker indispo, mais on log en dev pour debug
    if (process.env.NODE_ENV !== "production") {
      console.warn("[analytics] track failed:", eventType, err?.message);
    }
  }
}

export function trackPageview() {
  track("pageview");
}
